/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import _axios from './AxiosBarrier';
import { auth } from '../Config/firebase';
import { addDocumentFirebase } from './firebaseApi';


export const addActivity = async (data) => {
  try {
    const activityDoc = {
      createdBy: data.createdBy || auth?.currentUser?.uid || 'anonymous',
      createdName: data.createdName || auth?.currentUser?.displayName || auth?.currentUser?.email || 'Anonymous',
      companyId: data.companyId,
      type: data.type,
      action: data.action,
      createdAt: new Date(),
      image: data.image || auth?.currentUser?.photoURL || '',
      ...(data.projectId && { projectId: data.projectId }),
      ...(data.outletId && { outletId: data.outletId }),
      ...(data.collection_path && { collection_path: data.collection_path }),
      ...(data.title && { title: data.title }),
    };

    const docRef = await addDocumentFirebase('activity', activityDoc, data.companyId);
    return docRef.id;
  } catch (error) {
    console.error('Error adding activity:', error);
    throw error;
  }
};


// export const addActivity = async (data,) => {
//   try {
//     const res = await _axios.post('/kanban-addActivity', data,);
//     return res.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const addSubscribeTopic = async (data,) => {
  try {
    const res = await _axios.post('/notification-subscribeTopic', data,);
    return res;
  } catch (error) {
    throw error?.response?.data || error
  }
};

export const addPostTopic = async (data,) => {
  try {
    const res = await _axios.post('/notification-postTopic', data,);
    return res;
  } catch (error) {
    throw error?.response?.data || error
  }
};

// Tambahkan fungsi-fungsi lain untuk API activity lainnya jika diperlukan
